import React from 'react';
import { motion } from 'framer-motion';
const items = ['OFFERTA DI LANCIO', 'IL KIT COMPLETO A 20 €', 'SCOPRI IL KIT →'];
export function AnnouncementBar() {
  return <div className="sticky top-0 z-50 w-full border-y-2 border-amber-500 bg-stone-100 text-emerald-900" data-id="element-17" data-mp="on67uig6jm5b">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-18" data-mp="ev0g99tub6qn">
        <p className="hidden items-center justify-center gap-3 text-xs font-medium tracking-wide md:flex" data-id="element-19" data-mp="euh82ktzrwpt">
          {items.map((item, index) => <React.Fragment key={item} data-id="element-20" data-mp="5uc0a9kvywb4" data-mpi={index}>
              {index > 0 && <span className="text-amber-500" aria-hidden="true" data-id="element-21" data-mp="5tizrqcit31f">✦</span>}
              {index === items.length - 1 ? <a href="#buy" className="font-bold underline-offset-4 transition-colors duration-150 ease-out hover:text-emerald-700 hover:underline" data-id="element-22" data-mp="vral439fv0x">
                  {item}
                </a> : <span className={index === 1 ? 'rounded-full bg-amber-500 px-2.5 py-0.5 font-bold text-emerald-950' : ''} data-id="element-23" data-mp="1v87brqh78iyx">
                  {item}
                </span>}
            </React.Fragment>)}
        </p>
        <a href="#buy" className="relative block overflow-hidden md:hidden" data-id="element-24" data-mp="67gt5bd3epsz">
          <span className="sr-only" data-id="element-25" data-mp="aa3qtswg34y3">{items.join(' · ')}</span>
          <motion.div aria-hidden="true" className="flex w-max items-center gap-4 whitespace-nowrap text-xs font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-26" data-mp="3sfggumslmxxc">
            {[0, 1, 2, 3].map(copy => <React.Fragment key={copy} data-id="element-27" data-mp="txuphe2pnatd">
                {items.map((item, index) => <React.Fragment key={item} data-id="element-28" data-mp="tx1e1zst3x4w" data-mpi={index}>
                    <span className={index === 1 ? 'font-bold text-amber-700' : ''} data-id="element-29" data-mp="f9gg0kasgo3u">{item}</span>
                    <span className="text-amber-500" data-id="element-30" data-mp="k7hvywcx47b3">✦</span>
                  </React.Fragment>)}
              </React.Fragment>)}
          </motion.div>
        </a>
      </div>
    </div>;
}